import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosConfig from "../../services/Axios";

export const fetchCountries = createAsyncThunk(
  "fetchCountries",
  async (thunkAPI) => {
    try {
      return await axiosConfig
        .get(process.env.REACT_APP_API_URL + "/api/countries?pagination=false")
        .then(async (response) => {
          let countries = response.data["hydra:member"];
          return countries;
        });
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const fetchCountry = createAsyncThunk(
  "fetchCountry",
  async (data, thunkAPI) => {
    try {
      return await axiosConfig
        .get(
          process.env.REACT_APP_API_URL +
            "/api/countries?pagination=false&isoCode2=" +
            data
        )
        .then(async (response) => {
          let countries = response.data["hydra:member"];
          let country = countries.find((c) => c.isoCode2 === data);

          return country;
        });
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const countrySlice = createSlice({
  name: "country",
  initialState: {
    entities: {},
    loading: false,
    state: null,
  },
  reducers: {
    fetchCountry,
    fetchCountries,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountry.fulfilled, (state, response) => {
        state.loading = false;
        if (response?.payload) {
          state.entities = response?.payload;
          state.state = response?.payload.state;
        }
      })
      .addCase(fetchCountries.fulfilled, (state, response) => {
        state.loading = false;
        if (response?.payload) {
          state.entities = response?.payload;
          state.state = response?.payload.state;
        }
      });
  },
});

export default countrySlice.reducer;
